const listItems = document.querySelectorAll('li.menu-item-has-children > a');
const goBackBtns = document.querySelectorAll('.menu-nav-go-back-button');

const query = window.matchMedia('(max-width: 1024px)');

const initSubMenuFunctionalityOnMobile = () => {
    goBackBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            const parentUl = btn.closest('ul');
            parentUl.classList.remove('open');
        });
    });

    const handleSubMenu = (ev) => {
        ev.preventDefault();
        const clickedLink = ev.currentTarget;
        const parent = clickedLink.closest('li');
        const nestedMenu = parent.querySelector('ul');
        nestedMenu.classList.add('open');
    };

    listItems?.forEach((listItem) => listItem.addEventListener('click', handleSubMenu));
};

const initSubMenuFunctionalityOnDesktop = () => {
    const menuContainer = document.querySelector('.MegaNav');
    if (!menuContainer) return;

    const handleSubMenu = (ev) => {
        ev.preventDefault();
        const clickedLink = ev.currentTarget;
        const parent = clickedLink.closest('li');
        const nestedMenu = parent.querySelector('ul');

        document.querySelectorAll('li.menu-item-has-children ul.open').forEach((menu) => {
            if (menu !== nestedMenu) {
                menu.classList.remove('open');
            }
        });

        nestedMenu.classList.toggle('open');
    };

    listItems?.forEach((listItem) =>
        listItem.addEventListener('click', (ev) => {
            if (listItem.classList.contains('MegaNav__itemLink')) {
                handleSubMenu(ev);
            }
        }),
    );

    document.addEventListener('click', (ev) => {
        if (!menuContainer.contains(ev.target)) {
            document
                .querySelectorAll('li.menu-item-has-children ul.open')
                .forEach((menu) => menu.classList.remove('open'));
        }
    });
};

if (query.matches) {
    initSubMenuFunctionalityOnMobile();
} else {
    initSubMenuFunctionalityOnDesktop();
}

const handleMenuMobile = (param) => {
    if (param.matches) {
        initSubMenuFunctionalityOnMobile();
    } else {
        initSubMenuFunctionalityOnDesktop();
    }
};

query.addEventListener('change', handleMenuMobile);
